const GET_TRANSLATIONS_URL = '/translation/common';
const ADD_TRANSLATIONS = 'ADD_TRANSLATIONS';

export { ADD_TRANSLATIONS, GET_TRANSLATIONS_URL };
